import { Navigate, Outlet } from 'react-router-dom'
import { AuthUser } from '../models/AuthUser'
import UserStorage from '../storages/UserStorage'

const PrivateRoute = () => {
    let authUser: AuthUser | null = UserStorage.getCurrentUser();
    let auth = authUser != null && authUser.refreshToken != null;

    return auth ? <Outlet /> : <Navigate to="/login" />
}
export default PrivateRoute;